import {Mapper} from '@s-ui/domain'

export class FromModelVersionsRawDataToModelVersionsVOMapper extends Mapper {
  constructor({
    config,
    fromCompetitorsRawDataToRelatedVehiclesListValueObjectMapper,
    fromRawVersionsToVehicleInsightsValueObjectMapper,
    fromVehicleOffersListRawDataToVehicleOffersListValueObjectMapper,
    modelVersionsValueObjectFactory,
    offerPriceValueObjectFactory
  }) {
    super()
    this._config = config
    this._offerPriceValueObjectFactory = offerPriceValueObjectFactory
    this._modelVersionsValueObjectFactory = modelVersionsValueObjectFactory
    this._fromCompetitorsRawDataToRelatedVehiclesListValueObjectMapper =
      fromCompetitorsRawDataToRelatedVehiclesListValueObjectMapper
    this._fromRawVersionsToVehicleInsightsValueObjectMapper = fromRawVersionsToVehicleInsightsValueObjectMapper
    this._includeVehicleInsights = false
    this._fromVehicleOffersListRawDataToVehicleOffersListValueObjectMapper =
      fromVehicleOffersListRawDataToVehicleOffersListValueObjectMapper
    this._DEFAULT_COMPETITORS_AMOUNT = 4
    this._SPACE_STRING = ' '
    this._LOW_DASH = '_'
  }

  _getCompetitorUrl({make, model}) {
    return this._replaceMultipleValuesAll(this._pagePathPattern, {':make': make, ':model': model})
      .toLocaleLowerCase()
      .replaceAll(this._SPACE_STRING, this._LOW_DASH)
  }

  _replaceMultipleValuesAll(str, replaceValuesObject) {
    const regExp = new RegExp(Object.keys(replaceValuesObject).join('|'), 'gi')
    return str.replace(regExp, function (matched) {
      return replaceValuesObject[matched.toLowerCase()]
    })
  }

  setParams({pageName, competitorsCount, includeInsights = false}) {
    this._competitorsCount = competitorsCount || this._DEFAULT_COMPETITORS_AMOUNT
    this._pagePathPattern = `${this._getPagePathPattern({pageName})}/`
    this._includeVehicleInsights = includeInsights
    return this
  }

  _getPagePathPattern({pageName}) {
    const {MODEL_DETAIL_PAGE_NAME, MODEL_SIZES_PAGE_NAME, MODEL_SIZES_PATH_PATTERN, WDYL_MAKE_MODEL_PATH_PATTERN} =
      this._config.get('page')
    switch (pageName) {
      case MODEL_SIZES_PAGE_NAME:
        return MODEL_SIZES_PATH_PATTERN
      case MODEL_DETAIL_PAGE_NAME:
      default:
        return WDYL_MAKE_MODEL_PATH_PATTERN
    }
  }

  _getImages({images = {}}) {
    const {dashboard, interior, trunk, rearSeat} = images
    return {dashboard, interior, trunk, rearSeat}
  }

  map = ({
    competitors,
    angledImageUrl: mainImage,
    images = {},
    lowerFinancedOfferPrice,
    lowerSpotOfferPrice,
    lowerVersionPrice,
    versions
  }) => {
    const hasSpotPrice = Boolean(lowerSpotOfferPrice)
    const hasMainImage = Boolean(mainImage)
    const hasFinancedPrice = Boolean(lowerFinancedOfferPrice)
    const {items} = this._fromVehicleOffersListRawDataToVehicleOffersListValueObjectMapper
      .map({vehicles: versions})
      .toJSON()
    const [firstItem] = items
    const {make, model} = firstItem

    const competitorsItems = competitors?.items
      ?.slice(0, this._competitorsCount)
      .map(({makeName, makeId, modelName, modelId, pictures = []}) => {
        return {
          imageUrl: pictures[0],
          make: makeName,
          makeId,
          model: modelName,
          modelId,
          url: this._getCompetitorUrl({make: makeName, model: modelName})
        }
      })
    const hasCompetitors = Boolean(competitorsItems)
    const hasImages = Boolean(Object.keys(images).length)

    return this._modelVersionsValueObjectFactory({
      make,
      model,
      items,
      lowerVersionPrice,
      ...(hasMainImage && {
        mainImage
      }),
      ...(hasImages && {
        images: this._getImages({images})
      }),
      ...(hasCompetitors && {
        competitors: this._fromCompetitorsRawDataToRelatedVehiclesListValueObjectMapper.map({
          items: competitorsItems
        })
      }),
      ...(this._includeVehicleInsights && {
        vehicleInsights: this._fromRawVersionsToVehicleInsightsValueObjectMapper.map({versions})
      }),
      ...(hasSpotPrice && {
        lowerSpotOfferPrice: this._offerPriceValueObjectFactory({
          ...lowerSpotOfferPrice
        })
      }),
      ...(hasFinancedPrice && {
        lowerFinancedOfferPrice: this._offerPriceValueObjectFactory({
          ...lowerFinancedOfferPrice
        })
      })
    })
  }
}
